// app/Shared/composables/reserves.ts

import type { AnyDraftPlayer } from "~/src/draft/domain/models/DraftPlayer";

interface UseReserves {
  getReserves: (
    reservesId: number,
    playerRole: "player" | "goalkeeper"
  ) => Promise<AnyDraftPlayer[] | undefined>;
}

export const useReserves = (): UseReserves => {
  return {
    getReserves,
  };
  async function getReserves(
    reservesId: number,
    playerRole: "player" | "goalkeeper"
  ): Promise<AnyDraftPlayer[] | undefined> {
    try {
      const path = `/api/v1/competition/reserves/${reservesId}/${playerRole}`;
      const reserves = await $fetch<any>(path);

      if (reserves) {
        return reserves;
      } else {
        console.error("Fetched reserves is null");
      }
    } catch (e) {
      console.error("Error fetching reserves", e);
    }
  }
};
